<template lang="pug">
  div
    app-divider.margin-medium-top(label="Spring Boot Actuator Dashboard", :showBorder="false")

    el-row(:gutter="20")
      el-col(:span="8")
        el-card
          div(slot="header") Status da Aplicação
          p(v-if="health") Saúde: {{ health.status }}
          p(v-else) Carregando...
          el-button(@click="fetchHealth") Atualizar

      el-col(:span="8")
        el-card
          div(slot="header") Informações do Sistema
          p(v-if="info") {{ info }}
          p(v-else) Carregando...
          el-button(@click="fetchInfo") Atualizar

      el-col(:span="8")
        el-card
          div(slot="header") Métricas
          el-select(v-model="selectedMetric", placeholder="Escolha uma métrica", @change="fetchMetricValue")
            el-option(v-for="metric in metricsList", :key="metric", :label="metric", :value="metric")
          p(v-if="metricValue") {{ metricValue }} {{ baseUnit }}
          p(v-else) Selecione uma métrica
          el-button(@click="fetchMetrics") Atualizar

    app-divider.margin-medium-top(label="Gerenciamento de Loggers", :showBorder="false")

    el-button(@click="openLoggersDialog") Gerenciar Loggers

    app-divider.margin-medium-top(label="Outros Endpoints", :showBorder="false")
    el-button(@click="fetchThreads") Thread Dump
    el-button(@click="fetchCaches") Caches
    el-button(@click="fetchMappings") Mappings

    app-divider.margin-medium-top(label="Ambiente da Aplicação", :showBorder="false")
    el-button(@click="fetchEnv") Ver Variáveis de Ambiente

    app-divider.margin-medium-top(label="Beans Gerenciados pelo Spring", :showBorder="false")
    el-button(@click="fetchBeans") Ver Beans Gerenciados

    el-dialog(title="Detalhes", :visible.sync="dialogVisible")
      pre {{ dialogData }}

    el-dialog(title="Variáveis de Ambiente", :visible.sync="envDialogVisible", width="70%")
      pre {{ envData }}

    el-dialog(title="Beans Gerenciados", :visible.sync="beansDialogVisible", width="70%")
      pre {{ beansData }}

    el-dialog(title="Gerenciamento de Loggers", :visible.sync="loggersDialogVisible", width="70%")
      el-table(:data="loggersList", stripe, v-loading="loading")
        el-table-column(label='Logger', prop='name')
        el-table-column(label='Nível Atual', prop='configuredLevel')
        el-table-column(label='Alterar Nível')
          template(slot-scope='scope')
            el-select(v-model="loggersList[scope.$index].configuredLevel", @change="updateLogger(scope.row.name, loggersList[scope.$index].configuredLevel)", clearable)
              el-option(v-for="level in logLevels", :key="level", :label="level", :value="level")
</template>

<script>
import axios from '@/utils/api'
import AppDivider from '@/components/AppDivider'

export default {
  components: { AppDivider },

  data () {
    return {
      health: null,
      info: null,
      metricsList: [],
      selectedMetric: '',
      metricValue: null,
      loggersList: [],
      logLevels: ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'OFF'],
      loading: false,
      dialogVisible: false,
      dialogData: '',
      loggersDialogVisible: false,
      baseUnit: '',
      envDialogVisible: false,
      envData: '',
      beansDialogVisible: false,
      beansData: ''
    }
  },

  created () {
    this.fetchHealth()
    this.fetchInfo()
    this.fetchMetricsList()
    this.fetchLoggers()
  },

  methods: {
    async fetchEnv () {
      try {
        const response = await axios({ url: 'actuator/env', method: 'GET' })
        this.envData = JSON.stringify(response, null, 2)
        this.envDialogVisible = true
      } catch (error) {
        this.$message.error('Erro ao carregar as variáveis de ambiente.')
      }
    },
    async fetchBeans () {
      try {
        const response = await axios({ url: 'actuator/beans', method: 'GET' })
        this.beansData = JSON.stringify(response.contexts, null, 2)
        this.beansDialogVisible = true
      } catch (error) {
        this.$message.error('Erro ao carregar os beans gerenciados.')
      }
    },
    async fetchHealth () {
      const response = await axios({url: 'actuator/health', method: 'GET'})
      this.health = response
    },
    async fetchInfo () {
      const response = await axios({url: 'actuator/info', method: 'GET'})
      this.info = response
    },
    async fetchMetricsList () {
      const response = await axios({url: 'actuator/metrics', method: 'GET'})
      this.metricsList = response.names
    },
    async fetchMetricValue () {
      if (!this.selectedMetric) return
      const response = await axios({url: `actuator/metrics/${this.selectedMetric}`, method: 'GET'})
      this.metricValue = response.measurements[0]?.value || 'N/A'
      this.baseUnit = response.baseUnit || 'N/A'
    },
    async fetchLoggers () {
      this.loading = true
      try {
        const response = await axios({url: 'actuator/loggers', method: 'GET'})
        this.loggersList = Object.entries(response.loggers).map(([name, value]) => ({
          name,
          configuredLevel: value.configuredLevel || 'INFO'
        }))
      } finally {
        this.loading = false
      }
    },
    async updateLogger (loggerName, level) {
      await axios({url: `actuator/loggers/${loggerName}`, data: { configuredLevel: level }, method: 'POST'})
      this.$message.success(`Nível de log de "${loggerName}" atualizado para ${level}`)
    },
    async fetchThreads () {
      const response = await axios({url: 'actuator/threaddump', method: 'GET'})
      this.showDialog(response)
    },
    async fetchCaches () {
      const response = await axios({url: 'actuator/caches', method: 'GET'})
      this.showDialog(response)
    },
    async fetchMappings () {
      const response = await axios({url: 'actuator/mappings', method: 'GET'})
      this.showDialog(response)
    },
    showDialog (data) {
      this.dialogData = JSON.stringify(data, null, 2)
      this.dialogVisible = true
    },
    openLoggersDialog () {
      this.fetchLoggers()
      this.loggersDialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.full-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/InfoSistema.vue